import { render, staticRenderFns } from "./activeOrder.vue?vue&type=template&id=38c9970c&scoped=true&"
import script from "./activeOrder.vue?vue&type=script&lang=js&"
export * from "./activeOrder.vue?vue&type=script&lang=js&"
import style0 from "./activeOrder.vue?vue&type=style&index=0&id=38c9970c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9970c",
  null
  
)

export default component.exports